{
  "REGISTER": {
    "TRY_WOOT": "Konto erstellen",
    "TITLE": "Registrieren",
    "TESTIMONIAL_HEADER": "Alles, was er braucht, ist ein Schritt, um vorwärtszugehen",
    "TESTIMONIAL_CONTENT": "Sie sind nur noch einen Schritt davon entfernt, Ihre Kunden zu gewinnen, zu binden und neue zu finden.",
    "TERMS_ACCEPT": "Durch die Erstellung eines Kontos stimmen Sie unseren <a href=\"https://chat.jarabot.com/terms-of-service\">Allgemeinn Geschäftsbedingungen</a> und unserer <a href=\"https://chat.jarabot.com/privacy-policy\">Datenschutzrichtlinie</a> zu",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Mit Google anmelden"
    },
    "COMPANY_NAME": {
      "LABEL": "Firmenname",
      "PLACEHOLDER": "Geben Sie Ihren Firmennamen ein, z. B.: Wayne Enterprises",
      "ERROR": "Firmenname ist zu kurz"
    },
    "FULL_NAME": {
      "LABEL": "Vollständiger Name",
      "PLACEHOLDER": "Geben Sie Ihren vollständigen Namen ein, z. B.: Bruce Wayne",
      "ERROR": "Vollständiger Name ist zu kurz"
    },
    "EMAIL": {
      "LABEL": "Geschäftliche E-Mail-Adresse",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Bitte geben Sie eine gültige Arbeits-E-Mail-Adresse ein"
    },
    "PASSWORD": {
      "LABEL": "Passwort",
      "PLACEHOLDER": "Passwort",
      "ERROR": "Das Passwort ist zu kurz",
      "IS_INVALID_PASSWORD": "Das Passwort sollte mindestens 1 Großbuchstaben, 1 Kleinbuchstaben, 1 Ziffer und 1 Sonderzeichen enthalten"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Bestätige das Passwort",
      "PLACEHOLDER": "Bestätige das Passwort",
      "ERROR": "Passwort stimmt nicht überein"
    },
    "API": {
      "SUCCESS_MESSAGE": "Registrierung erfolgreich",
      "ERROR_MESSAGE": "Es konnte keine Verbindung zum Woot Server hergestellt werden. Bitte versuchen Sie es später erneut"
    },
    "SUBMIT": "Konto erstellen",
    "HAVE_AN_ACCOUNT": "Haben Sie bereits ein Konto?",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Allgemeine Geschäftsbedingungen</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Datenschutzrichtlinie</a>"
  }
}
